<script setup lang="ts">
import { VisibilitySpectrum } from '@/core/Common'
import Collection from '@/core/resources/Collection'

defineProps({
  collection: {
    type: Object as () => Collection,
    required: true
  }
})
const selected = defineModel<boolean>()

const emit = defineEmits(['export'])
</script>

<template>
  <tr
    :class="{
      selected: selected,
      published: collection.visibility === VisibilitySpectrum.DISPLAY,
      hidden: collection.visibility === VisibilitySpectrum.HIDDEN,
      ready: collection.visibility === VisibilitySpectrum.READY
    }">
    <td>
      <input type="checkbox" v-model="selected" />
    </td>
    <td class="name-column">
      <span>{{ collection.name }}</span>
    </td>
    <td class="visibility-column">
      <span>{{ collection.visibility }}</span>
    </td>
    <td class="accessibility-column">
      <span>{{ collection.accessibility }}</span>
    </td>
    <td class="role-column">
      <span>{{ collection.role }}</span>
    </td>
    <td class="updated-column">
      <span>{{ collection.updateDate.toLocaleDateString() }} {{ collection.updateDate.toLocaleTimeString() }}</span>
    </td>
    <td class="created-column">
      <span>{{ collection.createDate.toLocaleDateString() }} {{ collection.createDate.toLocaleTimeString() }}</span>
    </td>
    <td class="export-column">
      <span class="material-symbols-outlined action build-archive" @click="emit('export', collection)"> exit_to_app </span>
      <router-link :to="{ name: 'edit-collection', params: { id: collection.name } }">
        <span class="material-symbols-outlined action edit"> edit </span>
      </router-link>
    </td>
  </tr>
</template>

<style scoped lang="scss">
@import '@/assets/styles/tableline.scss';

.visibility-column,
.accessibility-column {
  max-width: 100px;
}

tr {
  &.published {
    background-color: var(--theme-success);
  }

  &.hidden {
    background-color: var(--theme-error);
  }

  &.ready {
    background-color: var(--theme-warning);
  }

  &:hover {
    background-color: var(--theme-panel-secondary);
  }
}
</style>
